import { Component, OnInit } from '@angular/core';
import { CommonService } from '../service/common.service';
import { MonshinService } from '../service/monshin.service';
import { ShareService } from '../service/share.service';
import { UsersService } from '../service/users.service';
import { Router } from '@angular/router';
import { AnswerStatus, Mode } from '../app.constant';
import { User } from '../service/users.model';
import { OutputService } from '../service/output.service';
import { YoyakuService } from '../service/yoyaku.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { B0001AcceptModalComponent } from './b0001-accept-modal.component';
import { MailService } from '../service/mail.service';
import { PersonService } from '../service/person.service';

@Component({
  selector: 'app-b0001-home',
  templateUrl: './b0001-home.component.html',
  styleUrls: ['./b0001-home.component.css']
})
export class B0001HomeComponent implements OnInit {

  constructor(
    private commonService: CommonService
    , private monshinService: MonshinService
    , private shareService: ShareService
    , private usersService: UsersService
    , private modalService: NgbModal
    , private router: Router
    , private outputService: OutputService
    , private yoyakuService: YoyakuService
    , private mailService: MailService
    , private personService: PersonService,
  ) { }

  homeInfoList: any;
  ANSWER_STATUS: any = AnswerStatus;
  MODE: any = Mode;
  userInfo: any;
  option_mendan_flg:any;
  online_flg:any;
  contract_company_id:any;
  mendan_status
  hantei_result: any = {
    hiro_hantei: [],
    suimin_hantei: [],
  };
  CategoryList: any;
  MendanList: any;

  ngOnInit() {
    //component読み込みのため、スクロール位置を固定で一番上に
    window.scrollTo(0, 0);
    //管理者権限の場合には管理者TOPに飛ばす処理を追加
    this.userInfo = this.usersService.userinfo;
    if ((this.userInfo.role_id == 2) || (this.userInfo.role_id == 999)) {
      this.router.navigate(["/admin"]);
    }

    //保持データのreflesh
    this.shareService.refleshAll();

    this.getHomeInfoList();
  }


  getHomeInfoList() {
    this.monshinService.getHomeInfoList()
      .subscribe((res: Response) => {

        if (res["fuel_status"] == "OK") {
          //管理者権限なのかの判定 → false=管理者
          if (res["fuel_results"]["role_check"] == false) {
            this.router.navigate(["/admin"]);
          }
          this.homeInfoList = res["fuel_results"]["home_list"];
          this.option_mendan_flg = res["fuel_results"]["home_list"][0]['option_mendan_flg']
          this.contract_company_id = res["fuel_results"]["home_list"][0]['contract_company_id']
          this.online_flg = res["fuel_results"]["online_flg"]
          this.CategoryList = res["fuel_results"]["home_list"][0]["language_list"][0]["category_list"][0];
          this.MendanList = res["fuel_results"]["home_list"][0]["language_list"][0]["mendan"][0];

        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(res["fuel_message"], modalresult => { });
        } else {
          this.commonService.modalOpens(11003, modalresult => { 
            // シボレス、システム双方がsession切れの場合、ログイン画面へ遷移
            // SSO対応しているserverのみ
            var page_url = location.href;
            var ssoAuth = page_url.includes("wellnessSupportToolsSec");
            if(ssoAuth){
              this.router.navigate(["/signin"]);
            }
          });
        }
      }, error => {
        this.commonService.modalOpens(error, modalresult => { });
    });
  }

  onAnswerStart(categoryInfo, mode = Mode.EDIT) {
    //選択した設問の情報を保持させる
    categoryInfo['hiro_flg'] = this.homeInfoList[0]['hiro_flg'];
    categoryInfo['suimin_flg'] = this.homeInfoList[0]['suimin_flg'];
    categoryInfo['option_mendan_flg'] = this.homeInfoList[0]['option_mendan_flg'];
    categoryInfo['monshin_pattern'] = 1;
    this.shareService.setCategoryInfoShare(categoryInfo);
    this.shareService.setModeShare(mode);

    this.getStartQuestionList(categoryInfo);

  }

  getStartQuestionList(categoryInfo): void {
    //全て表示フラグをfalseへ設定する
    let settingMonsinInfo = {
      'has_SPError': false,
      'chemical_alldisp': false,
      'organic_alldisp': false
    };

    //0102と同じようにparamsを作成しGetに投げる処理の実装
    let params = {
      "t_person_id": categoryInfo["t_person_id"],
      "t_event_id": categoryInfo["t_event_id"],
      "t_question_category_id": categoryInfo["t_question_category_id"],
      "m_question_category_id": categoryInfo["m_question_category_id"],
      "m_language_id": categoryInfo["m_language_id"],
    };

    this.monshinService.getStartQuestionList(params)
      .subscribe((res: Response) => {
        let startQuestionList = [];
        if (res["fuel_status"] == "OK") {
          //questionListが0レコードならエラー
          startQuestionList = res["fuel_results"]["question_list"] != null ? res["fuel_results"]["question_list"] : [];
          for (let i in startQuestionList) {
            if (startQuestionList[i].m_question_type_id == "6") {
              //回答にhidden_flgがあれば、化学その他リストボタンをOPENしておく
              settingMonsinInfo.chemical_alldisp = this.shareService.checkSPPreviousError(startQuestionList[i]);
            } else if (startQuestionList[i].m_question_type_id == "7") {
              //回答にhidden_flgがあれば、有機その他リストボタンをOPENしておく
              settingMonsinInfo.organic_alldisp = this.shareService.checkSPPreviousError(startQuestionList[i]);
            }
            if (startQuestionList[i]['previous_flg'] == "1") {
              if (startQuestionList[i]['t_result_list']['previous_result_id'] == null) {
                //過去回答参照で化学物質回答がない*プレビュー以外は進めない
                settingMonsinInfo.has_SPError = true;
              }
            }
          }
          this.shareService.setSettingMonsinInfo(settingMonsinInfo);

          if (startQuestionList.length > 0) {
            this.router.navigate(["/answer/start"]);
          } else {
            //結果データを空で保持
            this.shareService.setStartResultListShare([]);

            this.router.navigate(["/answer/main"]);
          }
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(res["fuel_message"], modalresult => { });
        } else {
          this.commonService.modalOpens(11003, modalresult => { });
        }
        //質問データの保持
        this.shareService.setStartQuestionListShare(startQuestionList);
      }, error => {
        this.commonService.modalOpens(error, modalresult => { });
      });
  }

  /**
   * 1ファイルでのダウンロード処理
   * @param tqc t_question_categoryレコード＋α
   */
  goOutputSingle(tqc): void {
    // 確認ダイアル
    this.commonService.modalOpens(53001,
      //ファイルを出力しますか？
      modalresult => {
        if (modalresult == "OK") {
          //OK時の処理
          let param = {
            't_event_id': tqc.t_event_id.toString(),
            'm_language_id': tqc.m_language_id,
            't_question_category_id': tqc.t_question_category_id.toString(),
            'mode': '3',
            'person_list': [tqc.t_person_id],
            'class_id': tqc.class_id,
            'class_nm': tqc.class_nm,
          };

          this.outputService.execOutputSingle(param)
            .subscribe((res: Response) => {
              if (res["fuel_status"] == "OK") {
                // download処理
                let downloadParam = {
                  't_output_history_id': res['fuel_results']['t_output_history_id'],
                }
                this.outputService.downloadFile(downloadParam);
              }
            });
        }
      }
    );

  }

  /****** 予約関連 ******/

  // 予約スタート
  onYoyakuStart(yoyakuInfo, mode = Mode.EDIT) {
    // yoyakuInfo = {
    //   "t_person_id": 5219,
    //   "t_yoyakuhyo_id": 1,
    //   "t_event_id": 156,
    //   "m_yoyakuhyo_id": 1,
    //   "t_course_id": 1,
    //   "point": 10,
    //   "m_language_id": 1,
    //   // ↓↓↓予約があれば値を展開
    //   "t_yoyaku_id": null,
    //   "m_division_1_id": null,
    //   "m_division_2_id": null,
    //   "update_datetime": null,
    // };

    //選択した予約情報を保持させる
    this.shareService.setCategoryInfoShare(yoyakuInfo);
    this.shareService.setModeShare(mode);

    this.router.navigate(["/yoyaku/main"]);
  
  }
  // 予約キャンセル
  onYoyakuCancel(yoyakuInfo, mode = Mode.EDIT) {
    // yoyakuInfo = {
    //   "t_person_id": 5219,
    //   "t_yoyakuhyo_id": 1,
    //   "t_event_id": 156,
    //   "m_yoyakuhyo_id": 1,
    //   "t_course_id": 1,
    //   "point": 10,
    //   "m_language_id": 1,      
    //   // ↓↓↓予約があるので下記はあるはず
    //   "t_yoyaku_id": 1,
    //   "m_division_1_id": 1,
    //   "m_division_2_id": 1,
    //   "update_datetime": "2020/06/12 1:18:10",
    // };
    //キャンセルしてもよろしいですか？を表示し、OKなら取消する
    this.commonService.modalOpens(50017,
      //キャンセルしてもよろしいですか？
      modalresult => {
          if (modalresult == "OK"){
                //取消処理
              yoyakuInfo['online_flg'] = this.online_flg;
              this.yoyakuService.cancelYoyaku(yoyakuInfo)
              .subscribe((res: Response) => {
                      if (res["fuel_status"] == "OK") {
                          this.commonService.modalOpens(10013,modalresult=>{
                            if (modalresult == "OK") {
                              let mode = res["fuel_results"]["mode"];
                              yoyakuInfo.mode = mode;
                              this.mailService.send(yoyakuInfo)
                              .subscribe((res: Response) => {                  
                                if (res["fuel_status"] == "OK") {                  
                                }                
                              });
                                //reloadする
                                this.getHomeInfoList();
                              }
                          });
                      }else if (res["fuel_status"] == "NG") {
                          this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                      }else{
                        var page_url = location.href;
                        var match = page_url .includes("wellnessSupportToolsSec");
                        if(match){
                          this.commonService.modalOpens(11013,modalresult=>{
                            this.router.navigate(["/signin/"]);
                          });
                        }
                        else{
                          this.commonService.modalOpens(11003,modalresult=>{});
                        }
                      }
                  },error => {
                      this.commonService.modalOpens(error,modalresult=>{});
                  });
          }else{
              //
          }
        }
      );
  }

  // 予約受付
  onYoyakuAccept(yoyakuInfo, mode = Mode.EDIT) {
    //modalでQRコードを表示
    const modalRef = this.modalService.open(
      B0001AcceptModalComponent,//対象のComponent
      { backdrop: 'static', keyboard: false, size: 'lg' }//オプション設定　Esc,背景クリックの時の処理…停止中
  );
    modalRef.componentInstance.tyid = yoyakuInfo.t_yoyaku_id;
    modalRef.componentInstance.tpid = yoyakuInfo.t_person_id;

  modalRef.result.then(
      result => {
          if (result.status == 'Cancel') {
              //Cancel時の処理
              location.reload();
          } else {
              //OK時の処理
              this.getHomeInfoList();
          }
      }, function () {
          // Esc,背景クリックの時の処理…オプション設定で停止中
      }
  );
    //戻ってきたら、reload
  }

  onMendanAnswerStart(categoryInfo, mode = Mode.EDIT) {
    //選択した設問の情報を保持させる
    categoryInfo['monshin_pattern'] = 2;
    this.shareService.setCategoryInfoShare(categoryInfo);
    this.shareService.setModeShare(mode);

    this.getMendanStartQuestionList(categoryInfo);

  }

  getMendanStartQuestionList(categoryInfo): void {
    //全て表示フラグをfalseへ設定する
    let settingMonsinInfo = {
      'has_SPError': false,
      'chemical_alldisp': false,
      'organic_alldisp': false
    };

    //0102と同じようにparamsを作成しGetに投げる処理の実装
    let params = {
      "t_person_id": categoryInfo["t_person_id"],
      "t_event_id": categoryInfo["t_event_id"],
      "t_addition_question_category_id": categoryInfo["t_addition_question_category_id"],
      "m_language_id": categoryInfo["m_language_id"]
    };

    this.monshinService.getMendanStartQuestionList(params)
      .subscribe((res: Response) => {
        let startQuestionList = [];
        if (res["fuel_status"] == "OK") {
          //questionListが0レコードならエラー
          startQuestionList = res["fuel_results"]["question_list"] != null ? res["fuel_results"]["question_list"] : [];
          for (let i in startQuestionList) {
            if (startQuestionList[i].m_question_type_id == "6") {
              //回答にhidden_flgがあれば、化学その他リストボタンをOPENしておく
              settingMonsinInfo.chemical_alldisp = this.shareService.checkSPPreviousError(startQuestionList[i]);
            } else if (startQuestionList[i].m_question_type_id == "7") {
              //回答にhidden_flgがあれば、有機その他リストボタンをOPENしておく
              settingMonsinInfo.organic_alldisp = this.shareService.checkSPPreviousError(startQuestionList[i]);
            }
            if (startQuestionList[i]['previous_flg'] == "1") {
              if (startQuestionList[i]['t_result_list']['previous_result_id'] == null) {
                //過去回答参照で化学物質回答がない*プレビュー以外は進めない
                settingMonsinInfo.has_SPError = true;
              }
            }
          }
          this.shareService.setSettingMonsinInfo(settingMonsinInfo);

          if (startQuestionList.length > 0) {
            this.router.navigate(["/answer/start"]);
          } else {
            //結果データを空で保持
            this.shareService.setStartResultListShare([]);

            this.router.navigate(["/answer/main"]);
          }
        } else if (res["fuel_status"] == "NG") {
          this.commonService.modalOpens(res["fuel_message"], modalresult => { });
        } else {
          this.commonService.modalOpens(11003, modalresult => { });
        }
        //質問データの保持
        this.shareService.setStartQuestionListShare(startQuestionList);
      }, error => {
        this.commonService.modalOpens(error, modalresult => { });
      });
  }

  teamsUrlCopy(yoyaku_id: any) {
    this.personService.postTeamsUrl(yoyaku_id)
    .subscribe((res: Response) => {
        const COPY_BT = document.getElementById("accept_" + yoyaku_id);
        let URL_TEXT = res["fuel_results"]["teams_url"];

        (navigator as any).clipboard.writeText(URL_TEXT);
        COPY_BT.classList.add("copy_bt_complete");
        setTimeout(() => {
        COPY_BT.classList.remove("copy_bt_complete");
        }, 3500);
    });
  }

  // マイナビ健診結果アップロード画面に遷移
  gouploadpage(te_id: any,tp_id: any){
    this.router.navigate(["/kenshin-upload/"+te_id+'/'+tp_id]);
  }

  // マイナビ再検査アップロード画面に遷移
  gosaikenuploadpage(tp_id: any){
    this.router.navigate(["/upload/"+tp_id]);
  }
}



// WEBPACK FOOTER //
// ./src/app/b0001-home/b0001-home.component.ts